import React, { useRef } from 'react';
import { C, FILTER_TYPES, inputStyle } from './shared';

const PRESETS = [
  { value: 'today',     label: 'Today'     },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'last_week', label: 'Week'      },
];

function presetDates(preset) {
  const today = new Date().toISOString().slice(0, 10);
  if (preset === 'today')     return { from: today, to: today };
  if (preset === 'yesterday') {
    const d = new Date(Date.now() - 86400000).toISOString().slice(0, 10);
    return { from: d, to: d };
  }
  if (preset === 'last_week') {
    return { from: new Date(Date.now() - 7 * 86400000).toISOString().slice(0, 10), to: today };
  }
  return { from: null, to: null };
}

export default function FilterRow({ filter, index, onUpdate, onRemove, onToggleOperator }) {
  const ft = FILTER_TYPES.find(t => t.value === filter.field);
  const debounceRef = useRef(null);

  function handleNum(field, raw) {
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      onUpdate(filter.id, { [field]: raw === '' ? null : +raw });
    }, 300);
  }

  const opActive = filter.operator === 'or';

  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
      {/* AND/OR badge */}
      {index > 0 && (
        <button
          onClick={() => onToggleOperator(filter.id)}
          style={{
            padding: '4px 10px', borderRadius: 5, fontWeight: 700, fontSize: 12,
            cursor: 'pointer', minWidth: 50, border: '1px solid',
            borderColor: opActive ? '#f59e0b' : C.primary,
            background: opActive ? '#fef3c720' : `${C.primary}10`,
            color: opActive ? '#f59e0b' : C.primary,
          }}
        >
          {filter.operator.toUpperCase()}
        </button>
      )}

      {/* Field label */}
      <span style={{ fontSize: 13, fontWeight: 600, color: C.text, minWidth: 100, paddingTop: 6 }}>
        {ft?.label}
      </span>

      {/* Date range */}
      {ft?.type === 'daterange' && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center' }}>
          {PRESETS.map(p => (
            <button key={p.value}
              onClick={() => {
                const isActive = filter.datePreset === p.value;
                onUpdate(filter.id, {
                  datePreset: isActive ? null : p.value,
                  ...(isActive ? { from: null, to: null } : presetDates(p.value)),
                }, true);
              }}
              style={{
                padding: '3px 8px', borderRadius: 5, fontSize: 11, cursor: 'pointer', fontWeight: 500,
                border: `1px solid ${filter.datePreset === p.value ? C.primary : C.border}`,
                background: filter.datePreset === p.value ? C.primary : '#fff',
                color: filter.datePreset === p.value ? '#fff' : C.textMd,
              }}
            >
              {p.label}
            </button>
          ))}
          <input type="date" value={filter.from ?? ''}
            onChange={e => onUpdate(filter.id, { from: e.target.value || null, datePreset: null })}
            style={{ ...inputStyle, width: 138 }} />
          <span style={{ color: C.textSm }}>→</span>
          <input type="date" value={filter.to ?? ''}
            onChange={e => onUpdate(filter.id, { to: e.target.value || null, datePreset: null })}
            style={{ ...inputStyle, width: 138 }} />
        </div>
      )}

      {/* Number range (300ms debounce) */}
      {ft?.type === 'numrange' && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <input type="number" placeholder="min"
            defaultValue={filter.from ?? ''}
            onChange={e => handleNum('from', e.target.value)}
            style={{ ...inputStyle, width: 90 }} />
          <span style={{ color: C.textSm, fontSize: 13 }}>{ft.unit ?? '%'}</span>
          <span style={{ color: C.textSm }}>—</span>
          <input type="number" placeholder="max"
            defaultValue={filter.to ?? ''}
            onChange={e => handleNum('to', e.target.value)}
            style={{ ...inputStyle, width: 90 }} />
          <span style={{ color: C.textSm, fontSize: 13 }}>{ft.unit ?? '%'}</span>
        </div>
      )}

      {/* Select */}
      {ft?.type === 'select' && (
        <select value={filter.value || ''}
          onChange={e => onUpdate(filter.id, { value: e.target.value || null }, true)}
          style={{ ...inputStyle, minWidth: 120, cursor: 'pointer' }}>
          <option value="">All</option>
          {ft.options.map(o => <option key={o} value={o}>{o}</option>)}
        </select>
      )}

      {/* ID search */}
      {ft?.type === 'id_search' && (
        <div>
          <input type="text" placeholder="571 or 560,570,580 or 560-580"
            value={filter.value ?? ''}
            onChange={e => onUpdate(filter.id, { value: e.target.value })}
            style={{ ...inputStyle, width: 260, fontFamily: 'monospace' }} />
          <div style={{ fontSize: 10, color: C.textSm, marginTop: 3 }}>
            Single: 571 · Multiple: 560,570,580 · Range: 560-580
          </div>
        </div>
      )}

      {/* Remove */}
      <button onClick={() => onRemove(filter.id)}
        style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: 18, padding: '2px 4px', lineHeight: 1, marginTop: 2 }}>
        ×
      </button>
    </div>
  );
}
